import React, { useState } from 'react'
import { TabsWrapper } from './componentsStyles'
import Tab from './elements/Tab'
import { Tabs_Props } from './interface'

export default function Tabs({ active, handleActive }: Tabs_Props) {
  return (
    <TabsWrapper>
      <Tab
        name={'my bets'}
        isActive={active === 'my bets'}
        handleActive={handleActive}
      />
      <Tab
        name={'all bets'}
        isActive={active === 'all bets'}
        handleActive={handleActive}
      />
      <Tab
        name={'high'}
        isActive={active === 'high'}
        handleActive={handleActive}
      />
    </TabsWrapper>
  )
}
